import React from 'react';
import { connect } from 'react-redux';
import '../../styles/QuillProMinayla.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import { setSelectedInvoices, openInvoiceModal, openDocumentsModal } from '../../actions/AccountingActions';

class InvoicesTable extends React.Component {
    state = {
        activeTab: 'all',
        searchTerm: '',
        pageIndex: 0,
        invoiceCounts: {},
        allSelected: false,
        selectedInvoices: [],
        clear: false
    };


    componentWillReceiveProps(nextProps) {
        if (nextProps.isClear !== this.state.clear) {
            this.setState({
                selectedInvoices: []
            })
        }
    }

    componentDidUpdate() {

        const { selectedInvoices, activeTab, searchTerm, pageIndex } = this.state;
        const { setSelectedInvoices, pageIndexParent, searchTermParent, activeTabParent, invoicesList, isClear } = this.props;

        if (selectedInvoices.length) {

            const selectedAmount = invoicesList.filter(i => selectedInvoices.includes(i.invoiceNumber)).reduce((sum, i) => sum += i.balance, 0);
            setSelectedInvoices([...selectedInvoices], selectedAmount);

        } else if (setSelectedInvoices) {

            setSelectedInvoices([], 0);
        }

        if (activeTabParent !== activeTab || searchTerm !== searchTermParent || pageIndex !== pageIndexParent) {
            this.setState({
                activeTab: activeTabParent,
                pageIndex: pageIndexParent,
                searchTerm: searchTermParent,
                allSelected: false,
                selectedInvoices: []
            });
        }
    }

    render() {

        let invoices = this.props.invoicesList || [];

        const { allSelected, activeTab } = this.state;
        const { openInvoiceModal, openDocumentsModal, searchTermParent } = this.props;

        if (searchTermParent.length) invoices = invoices.filter(invoice => {
            for (let key of Object.keys(invoice)) {
                if (key === 'statusId') continue;
                let value = invoice[key];
                if (typeof (value) !== 'string') value = value.toString();
                if (value.toUpperCase().includes(searchTermParent.toUpperCase())) return true;
            }

            return false;
        });

        return (
            <div className="card mb-4" style={{ height: 'auto' }}>
                <table className="table table-striped table-hover minayla-table">
                    <thead>
                        <tr>
                            {
                                activeTab === 'paid' ? null :
                                    <th className="d-flex justify-content-center align-items-center p-0 pr-3 pl-3" style={{ height: 80 }}>

                                        <div className="custom-control custom-checkbox m-0 p-0 pr-3">
                                            {allSelected ?
                                                <input type="checkbox"
                                                    className="custom-control-input"
                                                    id="checkbox-all"
                                                    onChange={() => this.setState({ allSelected: false, selectedInvoices: [] })}
                                                    checked />
                                                :
                                                <input type="checkbox"
                                                    className="custom-control-input"
                                                    id="checkbox-all"
                                                    onChange={() => this.setState({ allSelected: true, selectedInvoices: invoices.filter((inv) => inv.statusId !== 21).reduce((arr, inv) => [...arr, inv.invoiceNumber], []) })} />}
                                            <label className="custom-control-label" htmlFor="checkbox-all"></label>
                                        </div>

                                    </th>
                            }
                            <th>Invoice No</th>
                            <th>Order No</th>
                            <th>Amount</th>
                            <th>Balance</th>
                            <th>Invoice Date</th>
                            <th>Due Date</th>
                            <th>Payment Date</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                        <tr id="gradient-row">
                            <td colSpan="10">
                                <div id="gradient-bar" className="bg-primary bg-gradient" />
                            </td>
                        </tr>
                    </thead>
                    {!this.props.isLoading && (<tbody>
                        {
                            !invoices.length ? <tr><td colSpan="10" className="text-center">NO INVOICE FOUND</td></tr>
                                :
                                invoices.map(invoice => {
                                    const status = invoice.statusName;
                                    let badgeClass = status === 'PAID' ? 'badge-bg-green' : (status === 'PAST DUE' ? 'badge-bg-red' : (status === 'OPEN' ? 'badge-bg-blue' : (status.includes('PARTIAL') ? 'badge-bg-orange' : '')));
                                    if (badgeClass.length) badgeClass += ' status-badge';

                                    return (
                                        <tr key={invoice.invoiceNumber}>
                                            {
                                                activeTab === 'paid' ? null :
                                                    <td className="d-flex justify-content-center align-items-center" style={{ border: 'none' }}>
                                                        {status === 'PAID' ? null
                                                            :
                                                            (<div className="custom-control custom-checkbox m-0 p-0 pr-3">
                                                                {
                                                                    <input type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={`checkbox-${invoice.invoiceNumber}`}
                                                                        onChange={() => this.setState({
                                                                            allSelected: false,
                                                                            selectedInvoices: this.state.selectedInvoices.includes(invoice.invoiceNumber) ?
                                                                                this.state.selectedInvoices.filter(si => si !== invoice.invoiceNumber) :
                                                                                [...this.state.selectedInvoices, invoice.invoiceNumber]
                                                                        })}
                                                                        checked={this.state.selectedInvoices.includes(invoice.invoiceNumber)} />
                                                                }
                                                                <label className="custom-control-label" htmlFor={`checkbox-${invoice.invoiceNumber}`}></label>
                                                            </div>)
                                                        }
                                                    </td>
                                            }
                                            <td>{invoice.invoiceNumber}</td>
                                            <td>{invoice.orderNumber}</td>
                                            <td>${invoice.totalAmount}</td>
                                            <td>${invoice.balance}</td>
                                            <td>{invoice.generationDate ? invoice.generationDate.replace(new RegExp(/[.]/g), '/') : ''}</td>
                                            <td>{invoice.dueDate ? invoice.dueDate.replace(new RegExp(/[.]/g), '/') : ''}</td>
                                            <td>{invoice.paymentDate ? invoice.paymentDate.replace(new RegExp(/[.]/g), '/') : ''}</td>
                                            <td>
                                                <div className={`mx-auto ${badgeClass}`}>{badgeClass.length ? invoice.statusName.toLowerCase() : invoice.statusName}</div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-row justify-content-center">
                                                    <button
                                                        className="btn btn-primary icon-btn mr-2"
                                                        onClick={() => openInvoiceModal(invoice.invoiceNumber, true)}
                                                        data-toggle="modal" data-target="#invoice-modal">
                                                        <FontAwesomeIcon icon={faFileInvoiceDollar} size="lg" />
                                                    </button>
                                                    <button
                                                        className="btn btn-primary icon-btn"
                                                        onClick={() => openDocumentsModal(invoice.invoiceNumber)}
                                                        data-toggle="modal" data-target="#invoice-modal">
                                                        <FontAwesomeIcon icon={faFolderOpen} size="lg" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                        }

                    </tbody>)}
                </table>
                {
                    this.props.isLoading && (
                        <div className='sweet-loading' style={{ textAlign: 'center' }}>
                            <ClipLoader
                                sizeUnit={"px"}
                                size={250}
                                color={'rgb(54, 215, 183)'}
                                loading={true}
                            />
                        </div>)
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        invoiceCounts: state.accountingData.counts,
        invoicesList: state.accountingData.list,
        isLoading: state.accountingData.isLoading,
        isClear: state.accountingData.isClear
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSelectedInvoices: (numbers, amount) => dispatch(setSelectedInvoices(numbers, amount)),
        openInvoiceModal: (invoiceNumber, isPdf) => dispatch(openInvoiceModal(invoiceNumber, isPdf)),
        openDocumentsModal: invoiceNumber => dispatch(openDocumentsModal(invoiceNumber))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesTable);


// WEBPACK FOOTER //
// ./src/view/Accounting/InvoicesTable.js